export default __webpack_public_path__ + "static/media/icon_website.5f1b261f.svg";